<template>
  <div class="home-view--wrap">
    <main-hero
      :price-locale="priceLocale"
      :pricing-options="pricingOptions"
    />

    <v-container class="py-8 py-sm-15">
      <launch-stream />
      <claims-view />

      <v-sheet class="pa-8 pa-sm-15 mb-15" color="white" rounded="xl">
        <plans-grid
          :pricing-options="pricingOptions"
          :premium-options="premiumOptions"
          :price-locale="priceLocale"
          :user-minimum="userMinimum"
          :user-maximum="userMaximum"
          :monthly-model="monthlyModel"
        >
          <template #append:subheading>
            <country-switch large class="my-4 my-lg-0 ml-lg-auto" />
          </template>
        </plans-grid>
      </v-sheet>
      <learn-more />
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useLocaleStore } from '@/stores/locale.js'
import { useInstancePrices } from '@/composables/useInstancePrices.js'

import ClaimsView from '@/components/ClaimsView.vue'
import LaunchStream from '@/components/LaunchStream.vue'
import LearnMore from '@/components/LearnMore.vue'
import MainHero from '@/components/MainHero.vue'
import PlansGrid from '@/components/PlansGrid.vue'
import CountrySwitch from '@/components/CountrySwitch.vue'

export default {
  name: 'home-view',

  components: {
    ClaimsView,
    LaunchStream,
    LearnMore,
    MainHero,
    PlansGrid,
    CountrySwitch,
  },

  setup () {
    const { locale, premiumOptions, pricingOptions, userMinimum, userMaximum, monthlyModel } = useInstancePrices()

    return {
      priceLocale: locale,
      premiumOptions,
      pricingOptions,
      userMinimum,
      userMaximum,
      monthlyModel,
    }
  },

  computed: {
    ...mapState(useLocaleStore, ['currentLocale', 'currency']),
  },

  watch: {
    currentLocale () {
      this.priceLocale = this.currentLocale
    }
  },

  mounted () {
    this.priceLocale = this.currentLocale
  },
}
</script>
